import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import type { OfferStatus } from '@recruitee/offers-types';

import type { CloseEventProps, CopiedShareUrl, PublishEventProps } from './jobs.analytics.types';

export type SocialMediaType = 'linkedin' | 'facebook' | 'x';

@Injectable()
export class JobsAnalytics extends AnalyticsBase {
  public readonly namespace: string = 'Jobs';
  public readonly requireViewContext: boolean = true;

  public trackPublish(props: PublishEventProps): void {
    this.track('Publish', props);
  }

  public trackClose(props: CloseEventProps): void {
    this.track('CloseJob', props);
  }

  public trackEdit(status: 'internal' | 'public' | 'draft' | 'closed' | 'archived'): void {
    this.track(
      'EditJob',
      { status },
      { integrations: { All: false, Mixpanel: true, Intercom: true } },
    );
  }

  public trackDuplicate(): void {
    this.track('Duplicate', {}, { integrations: { All: false, Mixpanel: true, Intercom: true } });
  }

  public trackViewJob(): void {
    this.track('ViewOffer');
  }

  public trackCopyJobLink(url: CopiedShareUrl): void {
    this.track('CopyURL', { url });
  }

  public trackAssignRequisitionToJob(hasSharedOpenings: boolean, jobStatus: OfferStatus) {
    this.track('AssignRequisitionToJob', { hasSharedOpenings, jobStatus });
  }

  public trackOpeningsFilled(count: number, isBasedOnRequisition: boolean) {
    this.track('OpeningsFilled', { count, isBasedOnRequisition });
  }

  public trackArchive(): void {
    this.track('Archive');
  }

  public trackDelete(): void {
    this.track('Delete');
  }

  public trackSaveNewUrl(): void {
    this.track('EditURL');
  }

  public trackShareOnSocialMedia(type: SocialMediaType): void {
    this.track('ShareOnSocialMedia', { type });
  }

  public trackCopyTrackableURL(source: string): void {
    this.track('CopyTrackableURL', { source });
  }

  public trackInsertFromTemplate(type: 'fillEmptyFields' | 'overrideData'): void {
    this.track('InsertFromTemplate', { type });
  }

  // AI translations
  public trackAiTranslationsTrigger(): void {
    this.track('AITranslateTrigger');
  }

  public trackAiTranslationsInsert(): void {
    this.track('AITranslateInsert');
  }

  public trackAiTranslationsImprove(): void {
    this.track('AITranslateImprove');
  }
}
